import moment from "moment-timezone";

import { useAccountStatus } from "hooks/useAccountStatus";

export function useDefaultTimezone() {
	const { timezone } = useAccountStatus();
	return timezone ? timezone : moment.tz.guess();
}
